import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=1f3dfb1f&scoped=true"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"
import style0 from "./OrderForm.vue?vue&type=style&index=0&id=1f3dfb1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3dfb1f",
  null
  
)

export default component.exports